import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useVisualHtmlEditorContext } from "./VisualHtmlEditor";

export const ElementAttr = ({path, name, value}) => {

  const [ editName, setEditName ] = useState(false);
  const [ editValue, setEditValue ] = useState(false);

  const [ editedName, setEditedName ] = useState(name);
  const [ editedValue, setEditedValue ] = useState(value);

  const { changeAttribName, changeAttribValue } = useVisualHtmlEditorContext();

  const nameInput = useRef();
  const valueInput = useRef();

  useEffect(()=>{
    if(editName){
      if (nameInput.current) {
        nameInput.current.focus();
        nameInput.current.select();
      }
    }
  }, [editName]);

  useEffect(()=>{
    if(editValue){
      if (valueInput.current) {
        valueInput.current.focus();
        valueInput.current.select();
      }
    }
  }, [editValue]);

  const handleNameChange = useCallback((event) => {
    setEditedName(event.target.value);
  }, []);

  const handleNameKeyDown = useCallback((event) => {
    var key = event.keyCode || event.which;
    if (key === 13) {
      setEditName(false);
      changeAttribName(name, editedName, path)
      //changeTagElement(tag, path);
      setEditValue(true);
    }
    if (event.key === "Escape") {
      setEditName(false);
      setEditedName(name);
    }
  }, [name, editedName, path])

  const handleNameBlur = useCallback((event) => {
    setEditName(false);
    changeAttribName(name, editedName, path)
    //changeTagElement(tag, path);
    setEditValue(true);
  }, [name, editedName, path]);

  const handleValueChange = useCallback((event) => {
    setEditedValue(event.target.value);
  }, [])

  const handleValueKeyDown = useCallback((event) => {
    var key = event.keyCode || event.which;
    if (key === 13 && event.ctrlKey) {
      changeAttribValue(path, name, editedValue);
      setEditValue(false);
    }
    if (event.key === "Escape") {
      setEditValue(false);
      setEditedValue(value);
    }
  }, [path, name, editedValue]);

  const handleValueBlur = useCallback((event) => {
    changeAttribValue(path, name, editedValue);
    setEditValue(false);
  }, [path, name, editedValue]);
 
  const handleNameClick = useCallback(() => {
    setEditName(true);
  }, []);

  const handleValueClick = useCallback(() => {
    setEditValue(true);
  }, []);

  const isShort = useMemo(() => editedValue.length < 80 && editedValue.split("\n").length === 1, [editedValue]);;

  const nameSpan = useMemo(() => <span className="vhe-attribute-name" onClick={handleNameClick}>{name}</span>, [handleNameClick]);
  const valueSpan = useMemo(() => <pre className="vhe-string" onClick={handleValueClick}>'{value}'</pre>, [handleValueClick]);

  const elementAttr = useMemo(()=>{
    if(!editName && !editValue){
      return <>{nameSpan}={valueSpan}</>;
    }
    else if(editName){ 
      return <><input 
        className="vhe-attribute-input vhe-attribute-name" 
        style={{minWidth: 50, width: (editedName.length + 1) * 13 / 1.33}} 
        ref={nameInput} type="text" 
        value={editedName} 
        onChange={handleNameChange} 
        onKeyDown={handleNameKeyDown} 
        onBlur={handleNameBlur}/>={valueSpan}</>;
    }
    else if(editValue) { 
      return (
        <>
          {nameSpan}= <textarea 
            className="vhe-attribute-input vhe-string" 
            rows={editedValue.split("\n").length} 
            style={{height: (editedValue?.split("\n")?.length || 1) * 26}} 
            ref={valueInput} 
            type="text" 
            onChange={handleValueChange} 
            onKeyDown={handleValueKeyDown} 
            onBlur={handleValueBlur}>{editedValue}</textarea>
        </>
      );
    }  
  }, [editName, editValue, editedValue, editedName, nameSpan, valueSpan, handleNameChange, handleNameKeyDown, handleNameBlur, handleValueChange, handleValueKeyDown, handleValueBlur]);
  return (
    <div className={isShort ? "vhe-attribute" : "vhe-attribute-large"}>
      {elementAttr}
    </div>
  )

}